import { matchPath } from "react-router-dom";
import {
  MANAGE_OFFERINGS_ROUTE_IDS,
  MANAGE_OFFERINGS_ROUTE_KEYS,
} from "features/ManageOfferings/constants/ManageOfferings.urlPaths";
import { MEMBERSHIP_APIS } from "../constants/Membership.apis";

export const MEMBERSHIP_RESOURCE_APIS = {
  [MANAGE_OFFERINGS_ROUTE_IDS[MANAGE_OFFERINGS_ROUTE_KEYS.MEMBERSHIPS]]: ({
    pathname,
  }) => {
    const matchResults = matchPath(pathname, {
      path: MANAGE_OFFERINGS_ROUTE_IDS[
        MANAGE_OFFERINGS_ROUTE_KEYS.MEMBERSHIPS
      ].slice(1),
    });
    return {
      api_end_point: MEMBERSHIP_APIS.getMembershipsList,
      queries: {
        community_listing_uuid: matchResults?.params?.listing_uuid,
      },
    };
  },
};
